// Ionic & Angular Imports
import {Component} from '@angular/core';
import {NavController, NavParams, Loading, LoadingController, Refresher } from 'ionic-angular';
import {AlertController } from 'ionic-angular';

// Components 
import { BasePage } from '../base.component';
import { ReportPage } from '../report/report.component';

// Services
import {rsReportSvc, IReport} from '../../services/report.service';
import {rsSessionSvc } from '../../services/auth.service';

@Component({
    templateUrl: 'continue-report.html',
})
export class ContinueReportPage extends BasePage 
{
    private contentList : IReport[] = undefined; 

    constructor( 
        protected alertCtrl : AlertController,
        private loadingCtrl : LoadingController,
        private navCtrl : NavController, 
        private navParams : NavParams,    
        private reportSvc : rsReportSvc,
        private authSvc : rsSessionSvc,
    ) {
        // Construct base class
        super( alertCtrl );

        // Retrieve the report list from NavParams
        this.contentList = this.navParams.get('reportList');
        this.sortContentList();
    }
    // Sorting method for ensuring our ContentList is always sorted by jobnumber (ie., oldest to newest entries)
    private sortContentList(reverse : boolean = false) {
        this.contentList.sort( (a,b) => {
            return reverse ? b.jobnumber - a.jobnumber : a.jobnumber - b.jobnumber;
        });
    }

    // Class method used by the template to refresh the ContentList
    public refreshContent( refresher : Refresher ) {
        // Spawn a spinner while the ContentList is being refreshed
        let loader : Loading = this.loadingCtrl.create( {
            content: 'Refreshing...'
        });
        loader.present().then( () => {
            // The spinner is loaded, so let's get our refreshed ContentList
            this.reportSvc.getReports()
            .subscribe( result => {
                // Data was received from our service 
                this.contentList = result;
                this.sortContentList();
            }, err => {
                // The operation failed, so let's handle this error 
                loader.dismiss().then( () => {
                    this.displayError( "There was an error refreshing the list.  Please try again later." ).then( () => {
                        refresher.complete();
                    });
                });
            }, () => {
                // The operation succeeded, let's dismiss our spinner and complete our refresh operation 
                loader.dismiss().then( () => {
                    refresher.complete();
                });
            });
        });
    }

    // Class method used by the template to select a report from the ContentList
    public selectContent( report : IReport ) {
        // Create an instance of our Loading object 
        let loader : Loading = this.loadingCtrl.create( {
            content: 'Loading...',
            dismissOnPageChange: false
        });      

        // Present the loader and starting retrieving report information
        loader.present().then( () => { 
            // Request report details using the report service
            this.reportSvc.getReport(report.id, true, true).subscribe( result => {
                // Data was received from the service, so let's navigate to the next page
            }, err => {
                // request failed, so let's dimiss our loader and display an error 
                loader.dismiss().then( () => {
                    this.displayError('There was an error retrieving the requested daily field report.  Please try again later.' );
                });
            }, () => {
                this.navCtrl.push( ReportPage, {loader: loader}, { 
                    animate: true, direction: 'forward'
                }).then( () => {                    
                    loader.dismiss();
                });
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/pages/continue-report/continue-report.component.ts